import { mergeClasses } from '@griffel/react';

import type { GriffelClassNames } from '../../util/classNames';
import { useTextAlign } from '../../util/styles/fluent9';

import type { HorizontalAlignment } from './VerticalAlign.types';

export const useClassNames = (horizontalAlign: HorizontalAlignment, className?: string): GriffelClassNames<'root'> => {
  const textAlign = useTextAlign({ align: horizontalAlign });

  return {
    root: mergeClasses(textAlign.className, className),
  };
};
